import IndexedDbWrapper from '../../core/wrappers/browserStorage/indexedDb-wrapper';

export async function deleteRequests(id: number) {
    IndexedDbWrapper.deleteItemFromDb('orderRequests', id);
    getRequests();
}
export const addToCache = (val: any) => {
    IndexedDbWrapper.addItemToDb('orderRequests', val);
};

export async function getRequests() {
    let val: any;
    await IndexedDbWrapper.getAllItemFromDb('orderRequests')
        .then((result) => {
            val = result;
        })
        .catch((error) => {
            console.log(error);
            val = null;
        });
    return val;
}

export type OrderDetailFilter = {
    startDate: string;
    endDate: string;
    Barcodes: string;
    orderNumber: string;
    shippingListNo: string;
    sellerName: string;
    paymentMethodId: number | string;
    shippingCompanyId: number | string;
    take: number;
    skip: number;
    storeCode: string;
    PhoneNumberbyCustomerId: string;
    PhoneNumberbyDelivery: string;
    orderStatusIds: string;
    IsDKoli: boolean;
    DPackageCargoShipmentCode: string;
    TrackingCode: string;
};

export const initialState = {
    filterInfo: {
        startDate: '',
        endDate: '',
        Barcodes: '',
        orderNumber: '',
        shippingListNo: '',
        sellerName: '',
        paymentMethodId: -1,
        shippingCompanyId: -1,
        take: 10,
        skip: 0,
        storeCode: '',
        PhoneNumberbyCustomerId: '',
        PhoneNumberbyDelivery: '',
        orderStatusIds: '-1',
        IsDKoli: false,
        DPackageCargoShipmentCode: '',
        TrackingCode: '',
    },
};
